import { Button, Center, Stack, Text, Title } from '@mantine/core';
import { type ReactNode } from 'react';
import { Link, Navigate, Outlet } from 'react-router-dom';
import { AuthPendingScreen } from './AuthPendingScreen';
import { AuthRoleErrorScreen } from './AuthRoleErrorScreen';
import { useAuth } from './useAuth';

/**
 * Guard de ruta FAIL-CLOSED para la zona protegida del panel.
 * - cargando sesión → estado de carga a pantalla completa
 * - comprobando rol → estado explícito; todavía no es una denegación
 * - error de rol     → error recuperable sin mostrar contenido protegido
 * - sin sesión      → redirige a /login
 * - logado sin rol  → pantalla "no autorizado" (no se filtra contenido admin)
 * - admin           → renderiza la ruta hija (<Outlet/>)
 */
export function RequireAdmin(): ReactNode {
  const { status, isAdmin, signOut } = useAuth();

  if (status === 'loading' || status === 'checking-role') {
    return <AuthPendingScreen checkingRole={status === 'checking-role'} />;
  }

  if (status === 'role-error') {
    return <AuthRoleErrorScreen />;
  }

  if (status === 'signed-out') {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return (
      <Center h="100vh">
        <Stack align="center" gap="sm" maw={420}>
          <Title order={3}>Acceso no autorizado</Title>
          <Text c="dimmed" ta="center">
            Tu cuenta no tiene permisos de administración en Ibercar.
          </Text>
          <Button component={Link} to="/account">Mi cuenta y solicitudes de acceso</Button>
          <Button variant="light" onClick={() => void signOut()}>
            Cerrar sesión
          </Button>
        </Stack>
      </Center>
    );
  }

  return <Outlet />;
}
